import React, { useContext, useEffect, useMemo, useState } from "react";
import FileList from "../../../FileList";
import FileUpload from "../../../FileUpload/index";
import { ToastContainer, toast } from "react-toastify";
import { createNewUser, updateUser } from "../../../../action/user.action";
import { useParams } from "react-router-dom";
import Loading from "../../../../util/Loading";
import { api } from "../../../../util/urlConfig";
import { TabTitle } from "../../../../util/titleChanger";
import { GlobalState } from "../../../../GlobalState";

export default function UserForm() {
  const { userId } = useParams();
  TabTitle(userId > 0 ? "Update User" : "Create User");
  const state = useContext(GlobalState);
  const [roles] = state.roleAPI.roles;
  const [userDetail] = state.userAPI.userDetail;
  const [id, setId] = state.userAPI.id;
  const [callback, setCallback] = state.userAPI.callback;

  const [files, setFiles] = useState([]);
  const [btnName, setBtnName] = useState("Save");
  const [focused, setFocused] = useState(false);
  const [values, setValues] = useState([]);

  //For auto complete state
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectRole, setSelectRole] = useState("");
  const suggestions = roles.filter((role) => role.name.toString().toLowerCase().includes(selectRole.toString().toLowerCase()));

  const handleSuggestionClick = (suggestion) => {
    setSelectRole(suggestion.name);
    setShowSuggestions(false);
    setValues({
      ...values,
      roleId: suggestion.id,
    });
  };

  const onChangeSelectRole = (e) => {
    setSelectRole(e.target.value);
  };

  const uploadHandler = (file) => {
    if (files.length !== 0) {
      toast.warn("Already uploaded a image!");
    } else {
      if (file) {
        setFiles([...files, file]);
      }
    }
  };

  const removeHandler = (filename) => {
    setFiles(files.filter((file) => file.name !== filename));
  };

  const handleFocus = (e) => {
    setFocused(true);
  };

  //Get value form input elements and assign into values states
  const onChangeValue = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  // ***Here is code for converting "Base64" to javascript "File Object".***

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  const convertAsImage = (url) => {
    const toDataURL = (url) =>
      fetch(url)
        .then((response) => response.blob())
        .then(
          (blob) =>
            new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            })
        );

    toDataURL(url).then((dataUrl) => {
      try {
        const parts = url.split("/"); // safer for URLs
        const filename = parts[parts.length - 1];
        const [nameImage, ext] = filename.split(".");

        const fileData = dataURLtoFile(dataUrl, `${nameImage}.${ext}`);
        setFiles([fileData]);
      } catch (error) {
        console.error("Error converting image URL to File:", error);
      }
    });
  };

  useEffect(() => {
    if (userId > 0) {
      setId(userId);
      setBtnName("Update");
      setValues({
        ...values,
        first_name: userDetail ? userDetail.first_name : "Test",
        last_name: userDetail ? userDetail.last_name : "Test",
        nic: userDetail ? userDetail.nic : "Test",
        contact_no: userDetail ? userDetail.contact_no : "Test",
        email: userDetail ? userDetail.email : "test@mail.com",
        status: userDetail ? userDetail.status : "Test",
        roleId: userDetail.role ? userDetail.role.id : "1",
      });

      roles.map((role) => {
        const role_id = userDetail.role ? userDetail.role.id : "1";
        if (role.id === role_id) {
          setSelectRole(role.name);
        }
      });
      const imgUrl = userDetail.upload_image ? api + "/" + userDetail.upload_image.image_url : {};
      if (Object.keys(imgUrl).length != 0) {
        convertAsImage(imgUrl);
      }
    }
  }, [roles, id, userId, userDetail]);

  const submitForm = (e) => {
    e.preventDefault();
    const form = new FormData();
    form.append("first_name", values.first_name);
    form.append("last_name", values.last_name);
    form.append("nic", values.nic);
    form.append("contact_no", values.contact_no);
    form.append("email", values.email);
    form.append("password", values.confirm_password);
    form.append("roleId", values.roleId);
    form.append("uploaded_file", files[0]);

    if (userId > 0) {
      form.append("status", values.status);
    }

    if (userId > 0) {
      updateUser(userId, form, (res) => {
        if (res.status === 200) {
          toast.success(res.data);
          setCallback(!callback);
        } else {
          toast.error(res.data);
          setCallback(!callback);
        }
      });
    } else {
      createNewUser(form, (res) => {
        if (res.status === 200) {
          toast.success(res.data);
          setCallback(!callback);
        } else {
          toast.error(res.data);
          setCallback(!callback);
        }
      });
    }
  };

  return !userDetail ? (
    <div className="form-container">
      <div className="loading-page-container">
        <Loading />
      </div>
    </div>
  ) : (
    <div className="form-container">
      <header>User Register Form</header>
      <form onSubmit={submitForm} className="form">
        <FileUpload uploadHandler={uploadHandler} />
        <FileList files={files} removeHandler={removeHandler} />

        <div className="input-box">
          <label htmlFor="first_name">First Name</label>
          <input
            type="text"
            name="first_name"
            id="first_name"
            value={values.first_name || ""}
            placeholder="Enter First Name"
            required
            pattern="^[A-Za-z ,]{3,}$"
            onBlur={handleFocus}
            focused={focused.toString()}
            onChange={onChangeValue}
          />
          <span>First name should be above 3 characters and shouldn't any spacial character</span>
        </div>

        <div className="input-box">
          <label htmlFor="last_name">Last Name</label>
          <input
            type="text"
            name="last_name"
            id="last_name"
            value={values.last_name || ""}
            placeholder="Enter Last Name"
            required
            pattern="^[A-Za-z ,]{3,}$"
            onBlur={handleFocus}
            focused={focused.toString()}
            onChange={onChangeValue}
          />
          <span>Last name should be above 3 characters and shouldn't any spacial character</span>
        </div>

        <div className="input-box">
          <label htmlFor="nic">NIC</label>
          <input
            type="text"
            name="nic"
            id="nic"
            value={values.nic || ""}
            placeholder="Enter NIC"
            required
            pattern="^(?:19|20)?\d{2}[0-9]{10}|[0-9]{9}[x|X|v|V]$"
            onBlur={handleFocus}
            focused={focused.toString()}
            onChange={onChangeValue}
          />
          <span>Invalid NIC number</span>
        </div>

        <div className="input-box">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            name="email"
            id="email"
            value={values.email || ""}
            placeholder="Enter Email"
            required
            pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
            onBlur={handleFocus}
            focused={focused.toString()}
            onChange={onChangeValue}
          />
          <span>Invalid email address</span>
        </div>

        <div className="input-box">
          <label htmlFor="contact_no">Contact No</label>
          <input
            type="text"
            name="contact_no"
            id="contact_no"
            value={values.contact_no || ""}
            placeholder="Enter Contact No"
            required
            pattern="^(?:0|94|\+94)?(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|912)(0|2|3|4|5|7|9)|7(0|1|2|4|5|6|7|8)\d)\d{6}$"
            onBlur={handleFocus}
            focused={focused.toString()}
            onChange={onChangeValue}
          />
          <span>Invalid contact number</span>
        </div>

        {userId > 0 ? (
          <div className="input-box">
            <label htmlFor="status">Status</label>
            <select className="select-box" name="status" id="status" value={values.status || ""} placeholder="Select status" onChange={onChangeValue}>
              <option value="">Select a status</option>
              <option value="Deactivated">Deactivated</option>
              <option value="Active">Active</option>
            </select>
            <span>Invalid contact no</span>
          </div>
        ) : (
          <>
            <div className="input-box">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                name="password"
                id="password"
                required
                pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$"
                onBlur={handleFocus}
                focused={focused.toString()}
                onChange={onChangeValue}
              />
              <span>Password should be 8-16 characters and include at least 1 letter and 1 special character!</span>
            </div>

            <div className="input-box">
              <label htmlFor="confirm_password">Confirm Password</label>
              <input type="password" name="confirm_password" id="confirm_password" required pattern={values.password} onBlur={handleFocus} focused={focused.toString()} onChange={onChangeValue} />
              <span>Password don't match!</span>
            </div>
          </>
        )}

        <div className="input-box">
          <label htmlFor="roleId">Role</label>
          <input value={selectRole} name="roleId" id="roleId" required onBlur={handleFocus} focused={focused.toString()} onChange={onChangeSelectRole} onFocus={() => setShowSuggestions(true)} />
          {showSuggestions && (
            <ul className="suggestions">
              {suggestions.map((suggestion) => (
                <li key={suggestion.id} onClick={() => handleSuggestionClick(suggestion)}>
                  {suggestion.name}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="form-button">
          <button type="submit" className="add_new">
            {btnName}
          </button>
        </div>
      </form>
      <ToastContainer />
    </div>
  );
}
